import React from "react";
import { FormGroup, Input, Button } from "reactstrap";
import { Trash2 } from "react-feather";
import { appendable_columns } from "../../../../../static/brands_wholesalers_data";

const LeadsImportStep2TableItem = ({
  table,
  appendableColumns,
  onTableColumnUnSelect,
  onTableColumnSelect,
}) => {
  return (
    <div
      className="mt-3 px-3 px-sm-5 py-3 w-100"
      style={{
        borderRadius: "5px",
        minHeight: "130px",
        backgroundColor: "#EFEEFC",
        border: "1px solid #2D2D2D",
        display: "flex",
        flexDirection: window.innerWidth < 576 ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div
        className="d-flex flex-column flex-sm-row align-items-center w-100 justify-content-between"
        style={{ flex: 1 }}
      >
        <div className="d-block d-sm-none w-100" style={{ fontSize: "12px", fontWeight: 500, color: "#697277" }}>
          FILE HEADER
        </div>
        <div
          className="w-100"
          style={{
            flex: 1,
            fontSize: window.innerWidth < 576 ? "14px" : "20px",
            fontWeight: 500,
            textTransform: "uppercase",
          }}
        >
          {table.column}
        </div>
        <div className="mt-2 d-block d-sm-none w-100" style={{ fontSize: "12px", fontWeight: 500, color: "#697277" }}>
          DATA
        </div>
        <div className="w-100" style={{ flex: 1, overflow: "hidden" }}>
          {table.data.map((d) => (
            <div
              key={d}
              style={{
                color: "#303334",
                fontSize: window.innerWidth < 576 ? "13px" : "16px",
                textTransform: "uppercase",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "150px",
              }}
            >
              {d}
            </div>
          ))}
          ...
        </div>
      </div>

      {table?.appendedValue ? (
        <div className="d-flex align-items-center" style={{ flex: 0.5, width: "100%" }}>
          <div style={{ textAlign: "center", flex: 0.8 }}>
            {appendable_columns?.find((c) => c?.id === table?.appendedValue)?.label}
          </div>
          <Button
            color="link"
            className="p-0"
            onClick={() => onTableColumnUnSelect(table.column)}
          >
            <Trash2 size={18} />
          </Button>
        </div>
      ) : (
        <div className="w-100 w-sm-auto mt-2 mt-sm-0" style={{ flex: 0.5 }}>
          <div className="d-block d-sm-none mb-2" style={{ fontSize: "14px", color: "#303334", fontWeight: 500, fontFamily: "Roboto" }}>
            APPEND FIRST
          </div>
          <FormGroup className="mb-0">
            <Input
              type="select"
              style={{
                backgroundColor: "white",
                textTransform: "uppercase",
                color: "#4E585E",
                fontWeight: 500,
              }}
              onChange={(e) => onTableColumnSelect(table.column, e.target.value)}
            >
              <option value=''>
                Select
              </option>
              {appendableColumns
                ?.sort((_, b) => b?.required)
                ?.map((column) => (
                  <option key={column.label} value={column?.id}>
                    {column?.label}
                    {column?.required ? " *" : ""}
                  </option>
                ))}
            </Input>
          </FormGroup>
        </div>
      )}
    </div>
  );
};

export default LeadsImportStep2TableItem;
